module.exports = __webpack_public_path__ + "media/images/talent/intro-logo-5f90ab2cc0bb38bf508b61004f13e432.png";